import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ManageApplicationsService {

  constructor(private http: HttpClient) { }

  getApplications(){
    return this.http.get<any>(`${environment.apiUrl}/v1/applicants/user-applications`)
  }

  deleteApplication(id){
    return this.http.delete<any>(`${environment.apiUrl}/v1/applicants/`+ id)
  }
}
